/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Form, Grid, GridSet, GridItem, Link, Group, Icon, ToolTip, SelectField, TextField } from '@insticator/insticator-ui'; // iui-material
import Upload from "material/ctas/upload/upload_container";
//styles
import styles from 'pages/dashboard/account/paymentinfo/selectmethod/directdeposit/directdeposit_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ DIRECT DEPOSIT ~~~~~~~~~~ ========== */
class DirectDeposit extends Component {
    constructor(props){
        super(props);
        this.formName = 'ACH';
    }

    componentDidMount(){
        if(this.props.paymentUUID)this.props.getACHInformation(false, this.formName, this.props.paymentUUID);
    }

    handleFileUpload = (file) => {
        this.props.uploadFile(file, this.formName);
        this.props.handleFileUpload(file)
    };

    handleFileDiscard = () =>{
        this.props.discardFile(this.formName);
        this.props.handleFileDiscard()
    };
    render() {

        let { bankAccountType, bankName, accountName, routingNumber, accountNumber } = this.props.fields;
        return(
            <Form formName={this.formName} editable={this.props.editable}>
                 <Grid klass={`directDeposit ${this.props.classes.directDeposit}`}>
                    <GridSet align={`horizontal`} >
                     <GridItem>
                          <SelectField type={`select`} name={`bankAccountType`} value={bankAccountType.value} valid={bankAccountType.valid} formName={this.formName} label={`Bank Account Type`} info={``} required
                                 options={[{ name:'business_checking', value:'BUSINESS_CHECKING', text:'Business checking' }, {name: 'business_savings', value: 'BUSINESS_SAVINGS', text: 'Business Savings'},
                                     { name:'personal_checking', value:'PERSONAL_CHECKING', text:'Personal checking' }, {name: 'personal_savings', value: 'PERSONAL_SAVINGS', text: 'Personal Savings'}]}/>
                        </GridItem>
                        <GridItem>
                          <TextField type={`text`} name={`bankName`} value={bankName.value} valid={bankName.valid} formName={this.formName} placeholder={`Comerica Bank`} label={`Bank Name`} required />
                     </GridItem>
                        <GridItem>
                          <TextField type={`text`} name={`accountName`} value={accountName.value} valid={accountName.valid} formName={this.formName} placeholder={`Company name`} label={`Account Name (Company Name)`} required />
                     </GridItem>
                 </GridSet>
                 <GridSet align={`horizontal`} >
                        <GridItem>
                          <TextField type={`text`} name={`routingNumber`} value={routingNumber.value} valid={routingNumber.valid} formName={this.formName} placeholder={`101010101`} label={`Routing number`} required />
                        </GridItem>
                        <GridItem>
                          <TextField type={`text`} name={`accountNumber`} value={accountNumber.value} valid={accountNumber.valid} formName={this.formName} placeholder={`**** 1010`} label={`Bank Account Number`} required />
                        </GridItem>
                        <GridItem>
                            <Group name={`upload-form valid-${this.props.fields.form.valid}`} >
                                <span>W9 Form <ToolTip align={`right`} action={`click`} content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}><Icon name={`exclamation-circle`} /></ToolTip></span>
                                <Upload fileName={this.props.fields.form.value.name} uploadDate={this.props.fields.form.value.updatedDate} accept={'application/pdf'} handleDiscard={this.handleFileDiscard} handleFileUpload={this.handleFileUpload} />
                                {/*this link will have to change based on this pages state from redux, if document is previously uploaded user will be able to download it*/}
                                <Link text={this.props.fields.form.value.formLink ? 'Download your W9 Form' : 'Download W9 Form Template'} color={`primary`} type={`external`} action={this.props.fields.form.value.formLink ? this.props.fields.form.value.formLink : 'https://www.irs.gov/pub/irs-pdf/fw9.pdf'} icon={`arrow-down`} iconRight/></Group>
                        </GridItem>
                    </GridSet>
                </Grid>
            </Form>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DirectDeposit);
